import { render } from "./DocumentUploader.vue?vue&type=template&id=0d4226b9&scoped=true"
import script from "./DocumentUploader.vue?vue&type=script&lang=js"
export * from "./DocumentUploader.vue?vue&type=script&lang=js"

import "./DocumentUploader.vue?vue&type=style&index=0&id=0d4226b9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4226b9"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
